import React, {useState, useEffect} from 'react';
import Breadcrumb from '../../common/breadcrumb';
import apiClient from "../../../utils/apiClient";
import {toast} from "react-toastify";
import TableReport from "../../common/table/table";
import CostCodesTableColumns from "./CostCodesTableColumns";
import ModalConfirmation from "../../common/modal/ModalConfirmation";
import {removeObjFromArray} from "../../../utils/arrayHelpers";
import CostCodesFormModal from "./CostCodesFormModal";
import {updateStateValue} from "../../../utils/stateHelpers";
import LoadingIndicator from "../../common/loadingIndicator";

const CostCodes = () => {
    const [tableData, setTableData] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [formModal, setFormModal] = useState({isOpen: false, action: 'create'});
    const [deleteModal, setDeleteModal] = useState({isOpen: false, message: <p></p>});
    const [filters, setFilters] = useState({
        isLoading: false,
    });

    // delete
    const onDelete = () => {
        apiClient
            .delete('costCodes/' + selectedRow.id)
            .then(response => {
                const newTableData = removeObjFromArray(tableData, "id", response.data.id)
                setTableData(newTableData);
                toast.success(response.data.message);
            })
            .catch()
            .then(function () {
                setDeleteModal({...deleteModal, isOpen: false})
            });
    }

    useEffect(() => {
        apiClient
            .get('costCodes')
            .then(response => {
                setTableData(response.data);
            })
            .then(function () {
                updateStateValue(setFilters,'isLoading', false);
            });
    }, []);

    return (
        <>
            <Breadcrumb title="Cost Codes" parent="Admin"/>
            <div className="container-fluid">
                <TableReport
                    columns={CostCodesTableColumns(setSelectedRow, setFormModal, setDeleteModal)}
                    data={tableData}
                    exportOptions={{pdf: false, xlsx: true, csv: true}}
                    getExportFileName={() => 'cost_codes'}
                    withGlobalSearch={true}
                    scrollable={true}
                />
                <CostCodesFormModal
                    title="Cost Code"
                    modal={formModal}
                    setModal={setFormModal}
                    tableData={tableData}
                    setTableData={setTableData}
                    selectedRow={selectedRow}
                />
                <ModalConfirmation
                    title="Delete Cost Code"
                    modal={deleteModal}
                    setModal={setDeleteModal}
                    onConfirm={onDelete}
                />
                <LoadingIndicator isLoading={filters.isLoading}/>
            </div>
        </>
    );
}

export default CostCodes;
